var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap-trigger-list" },
    [
      _vm.isLoading ? _c("j-loading-trigger-list") : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center"
                },
                [
                  _c("div", { staticClass: "add-trigger" }, [
                    _c("p", { staticClass: "label-add-trigger" }, [
                      _vm._v("Trigger Event")
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "btn-add-trigger",
                        on: {
                          click: function($event) {
                            _vm.toggleModalAdd(true)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-plus" }),
                        _vm._v(" Add\n        ")
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.masterTriggers.length > 0
                    ? _c("div", { staticClass: "search-trigger" }, [
                        _c("i", { staticClass: "fa fa-search" }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.search,
                              expression: "search"
                            }
                          ],
                          attrs: { type: "text", placeholder: "Search Title" },
                          domProps: { value: _vm.search },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.search = $event.target.value
                            }
                          }
                        })
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.masterTriggers.length > 0
                ? _vm._l(_vm.triggers, function(trigger) {
                    return _c(
                      "div",
                      { key: trigger.id, staticClass: "trigger" },
                      [
                        _c("div", { staticClass: "section-left" }, [
                          _c("img", {
                            attrs: {
                              alt: "icon-trigger-" + trigger.name,
                              src: require("@/assets/automation/trigger.svg"),
                              width: "15",
                              height: "15"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "id-trigger" }, [
                            _vm._v(_vm._s(trigger.id))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "wrap-event-trigger" }, [
                            _c(
                              "div",
                              {
                                staticClass: "event-trigger",
                                class:
                                  "event-" +
                                  _vm.getEvent(trigger).replace("record_", "")
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getEvent(trigger).replace("_", " ")
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "name-trigger" }, [
                            _vm._v(_vm._s(trigger.name))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-right" }, [
                          _c("div", { staticClass: "lines" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "status-trigger",
                              class: trigger.is_active
                                ? "status-on"
                                : "status-off"
                            },
                            [
                              _c("div", { staticClass: "circle-accent" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(trigger.is_active ? "ON" : "OFF"))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "lines" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c(
                                "div",
                                { staticClass: "wrap-btn-action mr-2" },
                                [
                                  _vm._m(0, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tooltip-component" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "wrap-timestamp" },
                                        [
                                          _vm._m(1, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "timestamp" },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatFullDateTime(
                                                      trigger.created_at
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatFullDateTime(
                                                      trigger.updated_at
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "wrap-btn-action mr-2" },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-external-link",
                                    staticStyle: { "margin-top": "6px" },
                                    on: {
                                      click: function($event) {
                                        _vm.onOpenNewTab(trigger)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tooltip-component" },
                                    [_vm._v("Open new tab")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "wrap-btn-action" }, [
                                _c("i", {
                                  staticClass: "fa fa-trash",
                                  on: {
                                    click: function($event) {
                                      _vm.onDeleteTrigger(trigger)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "tooltip-component" },
                                  [_vm._v("Delete trigger")]
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.masterTriggers.length === 0
                ? _c("p", { staticClass: "trigger-not-found" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.isHaveData
                            ? "All trigger data has been displayed"
                            : "No triggers registered"
                        ) +
                        "\n    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isHaveData
                ? _c("div", { staticClass: "custom-pagination" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn-previous",
                        style: [
                          _vm.page === 1
                            ? { opacity: "0.5", cursor: "not-allowed" }
                            : ""
                        ],
                        on: { click: _vm.previousPage }
                      },
                      [_c("i", { staticClass: "fa fa-chevron-left" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn-forward",
                        style: [
                          _vm.masterTriggers.length < 100
                            ? { opacity: "0.5", cursor: "not-allowed" }
                            : ""
                        ],
                        on: { click: _vm.nextPage }
                      },
                      [_c("i", { staticClass: "fa fa-chevron-right" })]
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowModalAdd
        ? _c("j-modal-add-trigger", {
            attrs: { id: _vm.idModalAdd },
            on: {
              "close-modal": function($event) {
                _vm.toggleModalAdd(false)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-icon" }, [
      _c("i", { staticClass: "fa fa-info", staticStyle: { cursor: "default" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "timestamp-type" }, [
      _c("p", [_vm._v("Created")]),
      _vm._v(" "),
      _c("p", [_vm._v("Updated")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a4872c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a4872c5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jFormTrigger.vue
// module id = null
// module chunks = 